import React, { useState, Component } from 'react';
import { CheckIcon, XIcon, ArrowRightIcon, XCircleIcon, SendIcon, ArrowUpRightIcon } from 'lucide-react';
export const PricingSection = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Create email body with form data
    const subject = encodeURIComponent(`Pricing Details Request from ${formData.name}`);
    const body = encodeURIComponent(`Name: ${formData.name}\nCompany: ${formData.company}\nEmail: ${formData.email}\nPhone: ${formData.phone}`);
    // Open mailto link in new window
    window.open(`mailto:info@salessource.nl?subject=${subject}&body=${body}`);
    // Show confirmation and reset form
    alert('Thank you for your interest! Your email client should open with your request details.');
    setShowForm(false);
    setFormData({
      name: '',
      company: '',
      email: '',
      phone: ''
    });
  };
  const pricingModels = [{
    name: 'Outsourced Conference Sales',
    description: 'Ideal for established events looking to maximize sponsorship revenue',
    features: ['Retainer + Commission Model', 'Full sponsorship sales cycle management', 'Dedicated account manager', 'Weekly progress reports', 'Sponsor relationship management', 'Contract negotiation & closing', 'Basic sponsor activation support'],
    notIncluded: ['Premium sponsor prospecting', 'Custom sponsorship package design', 'On-site sponsor management']
  }];
  return <section id="pricing" className="py-24 bg-[#f5f5f5]" data-id="element-222">
      <div className="container mx-auto px-6" data-id="element-223">
        <div className="mb-5" data-id="element-224">
          <span className="text-black font-medium inline-flex items-center gap-2 bg-white/70 px-4 py-1.5 rounded-full shadow-sm" data-id="element-225">
            <div className="w-6 h-6 bg-[#FF7A39] rounded-sm" data-id="element-226"></div>
            Pricing
          </span>
        </div>
        <div className="mb-16" data-id="element-227">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6" data-id="element-228">
            Transparent{' '}
            <span className="font-serif italic text-[#FF7A39]" data-id="element-229">pricing</span>{' '}
            model
          </h2>
          <p className="text-xl text-black/80 max-w-2xl leading-relaxed" data-id="element-230">
            Flexible pricing structure aligned with your event goals and budget
          </p>
        </div>
        {/* Pricing Models */}
        <div className="grid grid-cols-1 md:grid-cols-1 gap-8 mb-16" data-id="element-231">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-all h-full flex flex-col mx-auto max-w-4xl w-full transform hover:-translate-y-1 duration-300" data-id="element-232">
            <div className="bg-black p-8 text-white" data-id="element-233">
              <h3 className="text-2xl font-bold mb-3" data-id="element-234">
                {pricingModels[0].name}
              </h3>
              <p className="text-white/80" data-id="element-235">{pricingModels[0].description}</p>
            </div>
            <div className="p-8 flex-grow grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-236">
              <div className="flex flex-col" data-id="element-237">
                <div className="mb-8 flex-grow" data-id="element-238">
                  <h4 className="font-bold text-black text-lg mb-5" data-id="element-239">
                    What's Included:
                  </h4>
                  <ul className="space-y-4" data-id="element-240">
                    {pricingModels[0].features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-241">
                        <span className="text-green-600 mr-3 mt-1 flex-shrink-0" data-id="element-242">
                          <CheckIcon size={18} data-id="element-243" />
                        </span>
                        <span className="text-black/70" data-id="element-244">{feature}</span>
                      </li>)}
                  </ul>
                </div>
                {pricingModels[0].notIncluded.length > 0 && <div className="mb-8" data-id="element-245">
                    <h4 className="font-bold text-black text-lg mb-5" data-id="element-246">
                      Premium Add-ons:
                    </h4>
                    <ul className="space-y-4" data-id="element-247">
                      {pricingModels[0].notIncluded.map((feature, i) => <li key={i} className="flex items-start" data-id="element-248">
                          <span className="text-[#FF7A39] mr-3 mt-1 flex-shrink-0" data-id="element-249">
                            <CheckIcon size={18} data-id="element-250" />
                          </span>
                          <span className="text-black/70" data-id="element-251">{feature}</span>
                        </li>)}
                    </ul>
                  </div>}
                <div className="mt-auto" data-id="element-252">
                  <a href="https://forms.gle/zspSVdBJ7eiHmqQj6" className="w-full text-center bg-[#FF7A39] hover:bg-[#FF7A39]/90 text-black font-medium py-3 px-6 rounded-md transition-all flex items-center justify-center gap-2 shadow-md" data-id="element-253">
                    Request Pricing Details <ArrowUpRightIcon size={18} data-id="element-254" />
                  </a>
                </div>
              </div>
              <div className="flex items-center justify-center" data-id="element-255">
                <div className="rounded-lg overflow-hidden shadow-md border border-gray-100 h-full w-full" data-id="element-256">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oXNEkFmiwrWLWJpTPjkad2/20230125_175051.jpg" alt="Conference venue with purple lighting" className="w-full h-full object-cover" data-id="element-257" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Email Form Modal */}
      {showForm && <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4" data-id="element-258">
          <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-8 relative" data-id="element-259">
            <button onClick={() => setShowForm(false)} className="absolute top-4 right-4 text-black/50 hover:text-black transition-colors" data-id="element-260">
              <XCircleIcon size={24} data-id="element-261" />
            </button>
            <h3 className="text-2xl font-bold text-black mb-6" data-id="element-262">
              Request Pricing Details
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-263">
              <div data-id="element-264">
                <label htmlFor="name" className="block text-sm font-medium text-black/70 mb-1" data-id="element-265">
                  Name:
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF7A39] transition-all" data-id="element-266" />
              </div>
              <div data-id="element-267">
                <label htmlFor="company" className="block text-sm font-medium text-black/70 mb-1" data-id="element-268">
                  Company:
                </label>
                <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF7A39] transition-all" data-id="element-269" />
              </div>
              <div data-id="element-270">
                <label htmlFor="email" className="block text-sm font-medium text-black/70 mb-1" data-id="element-271">
                  Email:
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF7A39] transition-all" data-id="element-272" />
              </div>
              <div data-id="element-273">
                <label htmlFor="phone" className="block text-sm font-medium text-black/70 mb-1" data-id="element-274">
                  Phone number:
                </label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF7A39] transition-all" data-id="element-275" />
              </div>
              <button type="submit" className="w-full mt-6 bg-[#FF7A39] hover:bg-[#FF7A39]/90 text-black font-medium py-3 px-6 rounded-md transition-all flex items-center justify-center gap-2 shadow-md" data-id="element-276">
                Submit Request <ArrowUpRightIcon size={18} data-id="element-277" />
              </button>
            </form>
          </div>
        </div>}
    </section>;
};